import { useNavigate } from "react-router-dom";
import { ProductGrid } from "../product";
import { SEO } from "../SEO";

export function FaithSection({ products, isPage }) {
  const navigate = useNavigate();
  const faithProducts = products.filter(p => p.collection === "Faith");
  
  const taglines = [
    "Covered by Grace. Built for the Grind.",
    "Walk by Faith. Move with Purpose.",
    "Kingdom Mindset. Street Certified.",
    "I Serve a God Who Never Fails — And Neither Do I."
  ];
  
  return (
    <section className={`py-20 px-4 ${isPage ? 'pt-32' : ''} bg-gradient-to-b from-black via-cyan-950/10 to-black`} data-testid="faith-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {isPage && <SEO title="Faith Collection" description="Fresh Po'Boy Faith Collection. Faith-driven streetwear designs. Wear your belief. Premium tees & hoodies." path="/faith" />}
          <span className="text-cyan-400 text-sm tracking-widest uppercase">Faith-Driven</span>
          <h2 className="text-white text-5xl sm:text-6xl font-bebas mt-2">Faith <span className="text-cyan-400">Collection</span></h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">Wear your faith. Inspire others. Premium faith-based streetwear.</p>
        </div>
        
        {isPage && (
          <div className="mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {taglines.map((tagline, index) => (
                <div 
                  key={tagline} 
                  className={`p-6 rounded-xl border ${index % 2 === 0 ? 'bg-red-600/10 border-red-600/30' : 'bg-cyan-400/10 border-cyan-400/30'} text-center`}
                >
                  <p className={`text-lg sm:text-xl font-bold ${index % 2 === 0 ? 'text-red-500' : 'text-cyan-400'}`}>
                    "{tagline}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <ProductGrid products={faithProducts} />
        {!isPage && faithProducts.length > 0 && (
          <div className="text-center mt-12">
            <button onClick={() => navigate('/faith')} className="px-8 py-4 bg-cyan-400 text-black font-semibold hover:bg-cyan-300 transition-colors" data-testid="view-faith-collection-btn">View Full Collection</button>
          </div>
        )}
      </div>
    </section>
  );
}
